import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { SET_MY_OFFERS_RESERVATION_UPDATES } from './duck/actions-reservation-updates'

export default function useReservationUpdates(listKey) {
  const dispatch = useDispatch()

  useEffect(() => {
    const setEnabled = enabled =>
      dispatch({
        type: SET_MY_OFFERS_RESERVATION_UPDATES,
        payload: { listKey, enabled }
      })

    setEnabled(true)
    return () => setEnabled(false)
  }, [dispatch, listKey])
}
